import { useMyOutOfOfficeQuery } from '@access-cms/api-client';

import { ApplicationInformationBanner } from '../ApplicationBanner';
import { useAuth } from '../auth/AuthContext';
import { CONTRACT_ROLE, useRBAC } from '../../hooks/useRBAC';

const ACTIVE_OOO_BANNER_HEADING = 'You have an active out-of-office reminder set.';
const ACTIVE_OOO_BANNER_MESSAGE =
  'Your contracts and approval tasks are assigned to someone else. You may end your out-of-office period at any time in your profile to resume your duties.';

function ActiveOutOfOfficeBanner() {
  const { isAuthenticated } = useAuth();
  const { roles } = useRBAC();
  const isCor = roles.some((role) => role.role_type === CONTRACT_ROLE.COR);
  const outOfOfficeQuery = useMyOutOfOfficeQuery({ enabled: isAuthenticated && isCor });
  const activePeriod = outOfOfficeQuery.data?.data?.find((period) => period.status === 'ACTIVE');

  if (!isAuthenticated || !isCor || !activePeriod) {
    return null;
  }

  return (
    <ApplicationInformationBanner
      bannerId={`active-out-of-office-${activePeriod.id}`}
      data-testid='active-out-of-office-banner'
      dismissalScope='session'
      heading={ACTIVE_OOO_BANNER_HEADING}>
      {ACTIVE_OOO_BANNER_MESSAGE}
    </ApplicationInformationBanner>
  );
}

export default ActiveOutOfOfficeBanner;
